import { SelectInputData } from "../../../../../components/deprecated/SelectInputField/SelectInputField";
import { NorwegianStandard, SystemsAndComponentsUtilities } from "../../../../../utils/systemsAndComponentsUtilities";
import { DataObjectType } from "../../DataObjects/DataObjectHelper";
import { FirebaseDataSelectField, FirebaseDataSelectFieldOption } from "../Generic/FirebaseDataSelectField";

export class FirebaseDataNorwegianStandardField<FirebaseDataType extends DataObjectType> extends FirebaseDataSelectField<
  NorwegianStandard,
  FirebaseDataType
> {
  encode = (value: NorwegianStandard) => value.id;
  override convertValueToSelectInput(value: NorwegianStandard): SelectInputData {
    return new SelectInputData(value.id + "", value.name);
  }
  getValueForKey(key: string): NorwegianStandard | undefined {
    const option = SystemsAndComponentsUtilities.getOptionWithKey(undefined, key);
    return option ? { id: option.id, name: option.title } : undefined;
  }
  getOptions(): FirebaseDataSelectFieldOption[] {
    return SystemsAndComponentsUtilities.getAllOptions().map((data) => {
      return {
        key: data.id,
        label: data.title,
      };
    });
  }
  getReadableStringRepresentation(value: NorwegianStandard): string {
    return value.name;
  }

  override isValueValid = (value: any): boolean => {
    return typeof value === "object" && value !== null && typeof value.id === "string" && typeof value.name === "string";
  };
}

